<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-12" style="margin-top: 30px">
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-button type="info" size="mini" @click="getData" circle><i class="fa-solid fa-rotate"></i>
            </el-button>
            &nbsp;&nbsp;&nbsp;
            <el-checkbox @change="getData" v-model="myData">{{$t('Mənim_hadisələrim')}}</el-checkbox>
            <el-checkbox @change="getData" v-model="startExpert">{{$t('ş_qəbul_edilməyib')}}</el-checkbox>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <el-input :placeholder="$t('Axtar')" v-model="search"> </el-input>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <el-table  v-loading="loading" :data="
          data.filter(
            (data) =>
              !search ||
              data.claimNumber
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase()) ||
              data.participants
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase())
          )
        " style="width: 100%">
          >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 90%;">
                <div class="col-11">
                  <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.participants"></span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('İşin_statusu')" width="300">
            <template slot-scope="scope">
              <status-label :type="
                scope.row.statusTypeId === 145
                  ? 'goldenrod'
                  : '' || scope.row.statusTypeId === 146
                    ? 'limeGreen'
                    : '' || scope.row.statusTypeId === 150
                      ? 'mediumBlue'
                      : '' || scope.row.statusTypeId === 151
                        ? 'forestGreen'
                        : '' || scope.row.statusTypeId === 160
                          ? 'success'
                          : ''
              " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>

       <el-table-column :label="$t('İş_#')" sortable prop="dispClaimNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispClaimNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Sığorta_növü_')" prop="insuranceTypeName" width="120">
          </el-table-column>
          <el-table-column :label="$t('Məsul_şəxs_/_Hüquqi_ekspert')" prop="legalExpertUserName">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs_/_Müştəri_xidməti')" prop="clientServiceUserName" width="210">
          </el-table-column>

          <el-table-column sortable :label="$t('HE_ötürülmə_tarixi_Gün_sayı')" prop="legalExpertStartDate" width="240">
          </el-table-column>

          <el-table-column align="right" fixed="right" width="30">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="text" style="padding: 0 !important">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ action: 'edit', row: scope.row }"><i
                      class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}</el-dropdown-item>
                  <el-dropdown-item @refresh-table="getData" :command="{ action: 'user', row: scope.row }"><i
                      class="fa-solid fa-person-circle-check"></i>Məsul şəxs
                    seç</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'approve', row: scope.row }"><i
                      class="fa-solid fa-check"></i>Təsdiqə
                    göndər</el-dropdown-item>
                  <el-dropdown-item divided></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <legal-expert-user @refresh-table="getData" ref="user" />
  </div>
</template>

<script>
import LegalExpertUser from "./LegalExpertUser.vue";
import StatusLabel from "../components/StatusLabel.vue";
import { GetClaimsLegalExpert } from "src/services/common";
import {
  SendToApprove,
} from "../../services/claim";
export default {
  components: {
    LegalExpertUser, StatusLabel
  },
  data() {
    return {
      myData: false,
      loading: false,
      startExpert: false,
      data: [],
      search: "",
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    handleCommand(command) {
      let item = command.row;
      if (command.action === "edit") this.handleEdit(item.id);
      else if (command.action === "user") this.handleUser(item);
      else if (command.action === "approve") this.handleApprove(item.id);
    },
    handleEdit(id) {
      this.$router.push({
        path: "claim/" + id,
      });
    },
    handleUser(item) {
      this.$refs["user"].edit(item);
    },
    handleApprove(id) {
      this.$confirm(this.$t('Təsdiqlənməyə_göndərilsin'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "info",
      })
        .then(() => {
          this.actloading = true;
          SendToApprove(id,this.uid).then((response) => {
            this.actloading = false;
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              } else {
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                this.getData();
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        })
        .catch(() => {
          this.loading = false;
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
    },

    getData() {
      this.loading = true;
      GetClaimsLegalExpert(this.myData, this.startExpert,this.uid).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data;
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
